import { List, ListItem, Typography } from '@mui/material';
import ProductTourContent from 'src/components/ProductTourContent';
import { IProductTour } from 'src/models/productTour';

export const SocmedOverviewStep: IProductTour = {
  title: 'Explore the Social Media Overview Page',
  menu: 'social-media',
  submenu: 'overview',
  steps: [
    {
      title: "Let's Explore the Social Media Overview Page!",
      content: (
        <ProductTourContent spacing={1}>
          This page gives you a quick overview of your social media performance
          — including engagement, followers, reach, and conversations.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Start the Tour'
    },
    {
      title: 'Open Overview Menu',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Click here to open the overview menu.
        </ProductTourContent>
      )
    },
    {
      title: 'Stats Overview',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Total Engagement: Total interactions collected across all
              platforms (likes, shares, comments).
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Total Followers: The total number of followers across all your
              social media channels.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Total Talk: The total number of conversations or mentions about
              your brand.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Total Reach: Potential number showing how many unique users have
              seen the Social Profile, Keyword, and, Hashtag.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Stats Overview',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Engagement Performance: Shows daily changes in likes, shares,
              comments, post count, and engagement rate.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Followers Growth: Displays follower movement on each platform to
              monitor growth or decline.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Stats Overview',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Reach Performance: Shows audience reach over time, viewable
              hourly, daily, weekly, or monthly.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Stats Overview',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Talk Performance: Displays the number of brand-related
              conversations each day — useful for monitoring spikes or trending
              issues.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Switch to by Media',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          This chart supports two metrics: Conversation and by Media. Switch to
          by Media to see the breakdown by platform.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Stats Overview - Conversation',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Breaks the chart down by each platform (YouTube, TikTok, Facebook,
          etc.). Use this to compare which media generates the most
          conversations.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Select Objects or Group',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Choose the objects or groups you want to use.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Select Objects',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Select one or more objects to use as your data source. On the overview
          page, all social media accounts and keywords are shown as available
          objects.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Select Group',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Select a group to use as your data source.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Advanced Search Settings',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Use advanced filters to refine your results based on source type,
          sentiment, emotion, age group, language, and more.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Advanced Search Settings',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Use these filters to refine your results and find exactly what you
          need.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Adjust Timeframe',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Adjust the timeframe to your preference here.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'The Final Step',
      content: (
        <ProductTourContent spacing={2}>
          All steps are complete. You've successfully finished this stage and
          are now ready to continue exploring and using all available features.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Finish'
    }
  ]
};
